import React from "react"
import { useTranslation } from "react-i18next"
import { Container, Row, Col } from "reactstrap"
import FeatherIcon from "feather-icons-react"

const ProcessSection = () => {
    const { t } = useTranslation()

    const steps = [
        { key: "analysis", icon: "search", number: "01" },
        { key: "design", icon: "edit-3", number: "02" },
        { key: "implementation", icon: "tool", number: "03" },
        { key: "support", icon: "headphones", number: "04" }
    ]

    return (
        <section className="section bg-light">
            <Container>
                {/* Section Title */}
                <Row className="justify-content-center">
                    <Col xs={12} className="text-center">
                        <div className="section-title mb-4 pb-2">
                            <h4 className="title mb-4">{t("process.title")}</h4>
                            <p className="text-muted para-desc mx-auto mb-0">
                                {t("process.subtitle")}
                            </p>
                        </div>
                    </Col>
                </Row>

                {/* Process Steps */}
                <Row>
                    {steps.map((step, key) => (
                        <Col lg={3} md={6} className="mt-4 pt-2" key={key}>
                            <div
                                className="card border-0 rounded shadow-lg text-center p-4 h-100"
                                style={{ backgroundColor: "#fff" }}
                            >
                                {/* Step Number Badge */}
                                <div className="mb-3">
                                    <span
                                        className="rounded-circle d-inline-flex align-items-center justify-content-center text-white fw-bold"
                                        style={{
                                            width: "50px",
                                            height: "50px",
                                            backgroundColor: "#E65100",
                                            fontSize: "18px"
                                        }}
                                    >
                                        {step.number}
                                    </span>
                                </div>

                                {/* Icon */}
                                <div className="mb-3">
                                    <FeatherIcon
                                        icon={step.icon}
                                        className="text-primary"
                                        style={{ width: "40px", height: "40px" }}
                                    />
                                </div>

                                {/* Title */}
                                <h5 className="text-dark fw-bold mb-3">
                                    {t(`process.steps.${step.key}.title`)}
                                </h5>

                                {/* Description */}
                                <p className="text-secondary mb-0" style={{ fontSize: "15px" }}>
                                    {t(`process.steps.${step.key}.description`)}
                                </p>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    )
}

export default ProcessSection
